const partners = [
  { name: 'Brantford Pediatrics', logoSrc: '/partners/brantford-peds.png' },
  { name: 'Ancaster Pediatrics', logoSrc: '/partners/ancaster-peds.jpg' },
  { name: 'Copper Ridge Medical Centre', logoSrc: '/partners/copper-ridge.png' },
  { name: 'Rapid Access Pediatrics', logoSrc: '/partners/rap-peds.png' },
];

// Duplicate for seamless infinite loop
const allPartners = [...partners, ...partners, ...partners];

export default function PartnerMarquee() {
  return (
    <section className="py-14 bg-gray-50 border-y border-gray-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8 text-center">
        <p className="text-sm font-semibold text-gray-400 uppercase tracking-widest">
          Trusted by clinics across Ontario
        </p>
        <p className="mt-2 text-xs text-gray-400">
          Presented at <span className="font-medium text-gray-500">e-Health 2026</span> · Halifax, NS
        </p>
      </div>

      {/* Marquee track */}
      <div className="marquee-track relative overflow-hidden">
        {/* Fade masks */}
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-gray-50 to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-gray-50 to-transparent z-10 pointer-events-none" />

        <div className="marquee-inner flex items-center gap-16 animate-marquee whitespace-nowrap w-max">
          {allPartners.map((partner, i) => (
            <div
              key={`${partner.name}-${i}`}
              className="flex flex-col items-center gap-3 flex-shrink-0"
            >
              <div className="h-16 w-40 flex items-center justify-center bg-white rounded-xl border border-gray-100 shadow-sm px-4 py-2">
                <img
                  src={partner.logoSrc}
                  alt={partner.name}
                  className="max-h-full max-w-full object-contain"
                  loading="lazy"
                />
              </div>
              <span className="text-xs text-gray-400 font-medium text-center max-w-[160px] leading-tight">
                {partner.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
